import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81f6f81e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contener" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "wind-turbines" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Turbiny", -1))
const _hoisted_7 = { class: "wind-turbines container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "pv-farms" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "FotFarm", -1))
const _hoisted_11 = { class: "pv-farms-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "pv" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "PV", -1))
const _hoisted_15 = { class: "pv-huawei" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Huawei", -1))
const _hoisted_17 = { class: "pv-huawei-container" }
const _hoisted_18 = { class: "pv-solarman" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Solarman", -1))
const _hoisted_20 = { class: "pv-solarman-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker_modal_component = _resolveComponent("date-picker-modal-component")!
  const _component_vensys_view = _resolveComponent("vensys-view")!
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_PVFarmView = _resolveComponent("PVFarmView")!
  const _component_installations_view = _resolveComponent("installations-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Admin Display "),
    _hoisted_2,
    _createVNode(_component_date_picker_modal_component, { onPickedDates: _ctx.fetchFromPickedDate }, null, 8, ["onPickedDates"]),
    _hoisted_3,
    _createTextVNode(" Dane z: " + _toDisplayString(_ctx.today) + " ", 1),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("h5", null, [
          _createTextVNode(" Produkcja: "),
          _createElementVNode("b", null, _toDisplayString(_ctx.vensys.totalProduction) + " kWh", 1)
        ]),
        _createVNode(_component_vensys_view, {
          turbines: _ctx.vensys.turbines
        }, null, 8, ["turbines"])
      ], 512), [
        [_vShow, _ctx.isLoaded]
      ])
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("h5", null, [
          _createTextVNode("Produkcja: "),
          _createElementVNode("b", null, _toDisplayString(_ctx.pv.sungrow.totalProduction) + " kWh", 1)
        ]),
        _createVNode(_component_PVFarmView, {
          pvFarms: _ctx.pv.sungrow.pvInstallations
        }, null, 8, ["pvFarms"])
      ], 512), [
        [_vShow, _ctx.isLoaded]
      ])
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _createElementVNode("h5", null, [
            _createTextVNode("Produkcja: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.pv.huawei.totalProduction) + " kWh", 1)
          ]),
          _createElementVNode("h5", null, [
            _createTextVNode("Zużycie: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.pv.huawei.totalUsedPower) + " kWh", 1)
          ]),
          _createVNode(_component_installations_view, {
            installations: _ctx.pv.huawei.pvInstallations
          }, null, 8, ["installations"])
        ], 512), [
          [_vShow, _ctx.isLoaded]
        ])
      ]),
      _withDirectives(_createVNode(_component_CSpinner, {
        color: "success",
        class: "spinner"
      }, null, 512), [
        [_vShow, !_ctx.isLoaded]
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _createElementVNode("h5", null, [
            _createTextVNode("Produkcja: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.pv.solarman.totalProduction) + " kWh", 1)
          ]),
          _createElementVNode("h5", null, [
            _createTextVNode("Zużycie: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.pv.solarman.totalUsedPower) + " kWh", 1)
          ]),
          _createVNode(_component_installations_view, {
            installations: _ctx.pv.solarman.pvInstallations
          }, null, 8, ["installations"])
        ], 512), [
          [_vShow, _ctx.isLoaded]
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ]))
}